const host = "https://api.pettrip.o-r.kr";
//const host = "http://192.168.27.250:5001";
//const host = "http://localhost:5000";
const corshost = "";

export default host;